import { USER_ENDPOINTS } from "./endpoints";
import type { User } from "./types";
import { fetchWithTimeout } from "../shared";

export default async function isUserLoggedIn(): Promise<User | null> {
  try {
    const response = await fetchWithTimeout(USER_ENDPOINTS.ME, { method: "GET" });
    if (!response.ok) return null;
    const data = await response.json();
    return data.user || null;
  } catch {
    return null;
  }
}
